'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerStyle = undefined;
var _themeUtilities = require('../theme-utilities');
var _themeUtilities2 = _interopRequireDefault(_themeUtilities);
var _marmaladeLogo = require('../../images/marmalade-logo.svg');
var _marmaladeLogo2 = _interopRequireDefault(_marmaladeLogo);
var _marmaladeLogoWhite = require('../../images/marmalade-logo-white.svg');
var _marmaladeLogoWhite2 = _interopRequireDefault(_marmaladeLogoWhite);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var footerStyle = exports.footerStyle = function footerStyle() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return _themeUtilities2.default.apply(undefined, ['Footer'].concat(styles));
};
var footerTheme = function footerTheme(baseTheme) {
  var _Object$assign;
  return Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, footerStyle('backgroundColor'), baseTheme.colorBlack), _defineProperty(_Object$assign, footerStyle('color'), baseTheme.colorWhite), _defineProperty(_Object$assign, footerStyle('paddingBottom'), baseTheme.space_md), _defineProperty(_Object$assign, footerStyle('paddingTop'), baseTheme.space_sm), _defineProperty(_Object$assign, footerStyle('legalText'), undefined), _defineProperty(_Object$assign, footerStyle('marmLogo'), _marmaladeLogoWhite2.default), _defineProperty(_Object$assign, footerStyle('marmLogoDark'), _marmaladeLogo2.default), _defineProperty(_Object$assign, footerStyle('poweredBy'), true), _defineProperty(_Object$assign, footerStyle('poweredByDark'), false), _Object$assign), baseTheme);
};
exports.default = {
  footerTheme: footerTheme,
  footerStyle: footerStyle
};